import { render, staticRenderFns } from "./SearchTerritorio.vue?vue&type=template&id=83fd9738&scoped=true&"
import script from "./SearchTerritorio.vue?vue&type=script&lang=js&"
export * from "./SearchTerritorio.vue?vue&type=script&lang=js&"
import style0 from "./SearchTerritorio.vue?vue&type=style&index=0&id=83fd9738&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fd9738",
  null
  
)

export default component.exports